import React, { useState, useEffect, useRef } from "react";
import PopUp from "./PopUp";
import ChoosFoodCart from "./ChoosFoodCart";
import KindFoodNav from "./KindFoodNav";
import { kabab } from "../assetss/data/food/kabab";
import { irani } from "../assetss/data/food/irani";
import { appetizer } from "../assetss/data/food/appetizer";
import { deser } from "../assetss/data/food/deser";
import { breakfast } from "../assetss/data/food/breakfast";
import { drink } from "../assetss/data/food/drink";
import { hotDrink } from "../assetss/data/food/hotDrink";
import { coldDrink } from "../assetss/data/food/coldDrink";
import { cake } from "../assetss/data/food/cake";
import { iceCream } from "../assetss/data/food/iceCream";



const ChooseFoodPart = ({ qty, setQty, onAdd, increase, decrease }) => {

  const [active, setActive] = useState(null);
  // const [active, setActive] = useState(false);
  const storedId = localStorage.getItem("visible");

  useEffect(() => {
    console.log(storedId);
  }, [storedId]);
  const [show, setShow] = useState(true)
  useEffect(() => {
    // Check if the popup has been shown before
    const popupShownBefore = sessionStorage.getItem('popupShown');

    if (popupShownBefore) {
      // If the popup has been shown before, do not show it again
      setShow(false);
    } else {
      // localStorage.setItem('popupShown' , 'true');
      // If the popup has not been shown before, show it and set the flag in localStorage
    }
  }, []); // Run this effect only once when the component mounts


  return (
    <div className="relative">
      <KindFoodNav storedId={storedId} active={active} setActive={setActive} />
      <ChoosFoodCart
        setActive={setActive}
        title="کباب‌ها"
        idName="kabab"
        kinds={kabab}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="ایرانی"
        idName="irani"
        kinds={irani}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="پیش‌غذاها"
        idName="appetizer"
        kinds={appetizer}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="دسرها"
        idName="deser"
        kinds={deser}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="صبحانه"
        idName="breakfast"
        kinds={breakfast}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="نوشیدنی"
        idName="drink"
        kinds={drink}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="نوشیدنی‌های گرم"
        idName="hotDrink"
        kinds={hotDrink}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="نوشیدنی‌های سرد"
        idName="coldDrink"
        kinds={coldDrink}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="کیک‌ها"
        idName="cake"
        kinds={cake}
      />
      <ChoosFoodCart
        setActive={setActive}
        title="بستنی‌ها"
        idName="iceCream"
        kinds={iceCream}
      />
      

      <PopUp show={show} setShow={setShow} />
    </div>
  );
};

export default ChooseFoodPart;
